import { getI18n } from 'react-i18next';

export const VALIDATION_CURRENCY_CODE_ALREADY_IN_USE = 'validation.currency.codeAlreadyInUse';
export const VALIDATION_CURRENCY_EMPTY_CODE = 'validation.currency.emptyCode';
export const VALIDATION_CURRENCY_INVALID_CODE_LENGTH = 'validation.currency.invalidCodeLength';
export const VALIDATION_CURRENCY_EMPTY_NAME = 'validation.currency.emptyName';
export const VALIDATION_CURRENCY_INVALID_NAME_LENGTH = 'validation.currency.invalidNameLength';
export const VALIDATION_CURRENCY_EMPTY_EXCHANGE_RATE = 'validation.currency.emptyExchangeRate';
export const VALIDATION_CURRENCY_NEGATIVE_EXCHANGE_RATE = 'validation.currency.negativeExchangeRate';
export const VALIDATION_CURRENCY_CANNOT_UPDATE_EUR = 'validation.currency.cannotUpdateEur';
export const VALIDATION_CURRENCY_NO_CURRENCY = 'validation.currency.noCurrency';
export const VALIDATION_CURRENCY_NO_EXCHANGE_RATE = 'validation.currency.noExchangeRate';
export const VALIDATION_CURRENCY_UNKNOWN_CURRENCY = 'validation.currency.unknownCurrency';
export const VALIDATION_CURRENCY_DEACTIVATED_CURRENCY = 'validation.currency.deactivatedCurrency';
export const ERROR_CURRENCY_NOT_FOUND = 'currency.notFound';
export const ERROR_CURRENCY_IS_ASSIGNED_TO_ZONE = 'currency.cannotBeDeleted.isAssignedToZone';
export const ERROR_CURRENCY_IS_EURO = 'currency.cannotBeDeleted.isEuro';
export const ERROR_CURRENCY_NO_DEACTIVATION = 'currency.noDeactivation';
export const ERROR_CURRENCY_NO_MODIFICATION = 'currency.noModification';

export const createCurrencyErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_CURRENCY_CODE_ALREADY_IN_USE:
            result = i18n.t('currencies.error.currency-code-already-used');
            break;
        case VALIDATION_CURRENCY_EMPTY_CODE:
            result = i18n.t('currencies.error.currency-empty-code');
            break;
        case VALIDATION_CURRENCY_INVALID_CODE_LENGTH:
            result = i18n.t('currencies.error.currency-invalid-code-length', { max: params[0] });
            break;
        case VALIDATION_CURRENCY_EMPTY_NAME:
            result = i18n.t('currencies.error.currency-empty-name');
            break;
        case VALIDATION_CURRENCY_INVALID_NAME_LENGTH:
            result = i18n.t('currencies.error.currency-invalid-name-length', { maxLength: params[0] });
            break;
        case VALIDATION_CURRENCY_EMPTY_EXCHANGE_RATE:
            result = i18n.t('currencies.error.currency-empty-exchange-rate');
            break;
        case VALIDATION_CURRENCY_NEGATIVE_EXCHANGE_RATE:
            result = i18n.t('currencies.error.currency-negative-exchange-rate');
            break;
        case VALIDATION_CURRENCY_CANNOT_UPDATE_EUR:
            result = i18n.t('currencies.error.currency-cannot-update-eur');
            break;
        case VALIDATION_CURRENCY_NO_CURRENCY:
            result = i18n.t('currencies.error.currency-no-currency', params);
            break;
        case VALIDATION_CURRENCY_NO_EXCHANGE_RATE:
            result = i18n.t('currencies.error.currency-no-exchange-rate', params);
            break;
        case VALIDATION_CURRENCY_UNKNOWN_CURRENCY:
            result = i18n.t('currencies.error.currency-unknown', params);
            break;
        case VALIDATION_CURRENCY_DEACTIVATED_CURRENCY:
            result = i18n.t('currencies.error.currency-deactivated', params);
            break;
        case ERROR_CURRENCY_NOT_FOUND:
            result = i18n.t('currencies.error.currency-not-found');
            break;
        case ERROR_CURRENCY_IS_ASSIGNED_TO_ZONE:
            result = i18n.t('currencies.error.currency-is-assigned-to-zone');
            break;
        case ERROR_CURRENCY_IS_EURO:
            result = i18n.t('currencies.error.currency-is-euro');
            break;
        case ERROR_CURRENCY_NO_DEACTIVATION:
            result = i18n.t('currencies.error.currency-no-deactivation');
            break;
        case ERROR_CURRENCY_NO_MODIFICATION:
            result = i18n.t('currencies.error.currency-no-modification');
            break;
        default:
            result = undefined;
    }
    return result;
};
